import { Link } from "react-router-dom";

export const Mark = ({ className = "h-9 w-9" }) => (
  <svg viewBox="0 0 40 40" className={className} aria-hidden="true">
    <defs>
      <linearGradient id="nsg" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0" stopColor="#3D6BFF" />
        <stop offset="0.6" stopColor="#6D3BF5" />
        <stop offset="1" stopColor="#A855F7" />
      </linearGradient>
    </defs>
    <rect width="40" height="40" rx="11" fill="url(#nsg)" />
    <path d="M9 29V11h3.2l8.3 12.2V11H24" fill="none" stroke="#fff" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M31 14.5c-.9-2-2.6-3-4.6-3-2.4 0-4 1.4-4 3.3 0 4.6 8.8 2.8 8.8 8.4 0 2.3-1.9 4.3-4.9 4.3-2.3 0-4-1-5-2.9" fill="none" stroke="#fff" strokeWidth="3" strokeLinecap="round" opacity="0.92" />
    <circle cx="32.5" cy="31.5" r="2.2" fill="#67E8F9" />
  </svg>
);

export const Wordmark = ({ light = true, size = "md" }) => {
  const s = size === "lg" ? { t: "text-[15px]", n: "text-[24px]" } : { t: "text-[12px]", n: "text-[19px]" };
  return (
    <span className="flex items-baseline gap-1.5 leading-none">
      <span className={`font-display ${s.t} font-medium uppercase tracking-[0.32em] ${light ? "text-white/90" : "text-slate-900"}`}>Studio<span className={light ? "text-cyan-400" : "text-blue-600"}>·</span>Web</span>
      <span className={`font-display ${s.n} font-extrabold tracking-[-0.04em] bg-clip-text text-transparent`} style={{ backgroundImage: light ? "linear-gradient(90deg,#67E8F9,#93C5FD,#C4B5FD)" : "linear-gradient(90deg,#2753F5,#7C3AED)" }}>NS</span>
    </span>
  );
};

export const Logo = ({ light = true, size, to = "/" }) => (
  <Link to={to} data-testid="header-logo" className="group flex items-center gap-3" aria-label="STUDIO WEB NS, home">
    <span className="transition-transform duration-300 group-hover:-rotate-6 group-hover:scale-105"><Mark className={size === "lg" ? "h-11 w-11" : "h-9 w-9"} /></span>
    <Wordmark light={light} size={size} />
  </Link>
);
